export class TipoOcorrenciaAluno {
	id: number;
	tipoOcorrencia: string;
	informaSAP: boolean;
	usuarioAlteracao: number;
}
